/**
 * MeetingStatusService
 * Service for MeetingStatus entity operations
 * Route: api/meetingstatuses
 * Controller: MeetingStatusesController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * MeetingStatusService
 * Handles meeting status CRUD operations
 * Maps to /api/meetingstatuses endpoint
 */
export class MeetingStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? MeetingStatusService.DEFAULT_SERVICE_PATH,
            basePath: MeetingStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
MeetingStatusService.DEFAULT_SERVICE_PATH = 'meetings';
MeetingStatusService.BASE_PATH = 'api/meetingstatuses';
//# sourceMappingURL=MeetingStatusService.js.map